"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAppBaseLookupValue = normalizeAppBaseLookupValue;
/**
 * The text a lookup key value is compared and keyed by: a text trimmed and in
 * NFKC, a finite number as `String(n)`, a flag as `true` or `false`. The row
 * locator of the platform puts this text into the HMAC lookup key of a row and
 * the StreamKit compares its local rows by it, so its bytes never change. Any
 * other value names no text: `null`, and the caller decides what that means.
 */
function normalizeAppBaseLookupValue(value) {
    if (typeof value === 'string')
        return value.trim().normalize('NFKC');
    if (typeof value === 'number' && Number.isFinite(value))
        return String(value);
    if (typeof value === 'boolean')
        return value ? 'true' : 'false';
    return null;
}
